import classNames from 'classnames'
import type { FC, MouseEvent, SyntheticEvent } from 'react'

import { widgetRegistry } from '@pages/IntroducingBroker/DashboardPoC/widgetRegistry'

import { IconButton } from '@ui/components/Button'
import { CloseIcon } from '@ui/icons/Close.icon'

import { WidgetType } from '../types'
import type { Widget } from '../types'
import { EditModeContext } from '../utils/WidgetEditModeContext'

import styles from './WidgetContainer.module.scss'

type WidgetContainerProps = {
  widget: Widget
} & (
  | { isEditMode?: false; onRemove?: never }
  | { isEditMode: true; onRemove: (type: WidgetType) => void }
)

export const WidgetContainer: FC<WidgetContainerProps> = ({ widget, isEditMode, onRemove }) => {
  const definition = widgetRegistry[widget.type]
  const Component = definition.component

  const stopGridInteraction = (event: SyntheticEvent) => {
    event.stopPropagation()
  }

  const handleRemove = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()

    if (isEditMode) {
      onRemove(widget.type)
    }
  }

  return (
    <EditModeContext.Provider value={Boolean(isEditMode)}>
      <div
        className={classNames(styles.widgetContainer, {
          [styles.editMode]: isEditMode,
        })}
      >
        {isEditMode && (
          <div
            className={styles.closeButton}
            onMouseDown={stopGridInteraction}
            onTouchStart={stopGridInteraction}
          >
            <IconButton.Secondary
              aria-label='Remove widget'
              size='sm'
              icon={CloseIcon}
              onClick={handleRemove}
            />
          </div>
        )}

        <div
          className={classNames(styles.content, {
            [styles.overflowVisible]: definition.allowOverflow,
          })}
        >
          <Component />
        </div>
      </div>
    </EditModeContext.Provider>
  )
}
